import { render } from "./BorrowDialog.vue?vue&type=template&id=4987bf21&scoped=true&ts=true"
import script from "./BorrowDialog.vue?vue&type=script&lang=ts"
export * from "./BorrowDialog.vue?vue&type=script&lang=ts"

import "./BorrowDialog.vue?vue&type=style&index=0&id=4987bf21&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4987bf21"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QTooltip,QSlider,QBtn,QField});
